import Config from '@/shared/constants/config';

const Actions = {
  Load: {
    START: 'r.reports-of-sickness.actions.load.start',
    SUCCESS: 'r.reports-of-sickness.actions.load.success',
    FAILED: 'r.reports-of-sickness.actions.load.failed'
  },
  LoadAll: {
    START: 'r.reports-of-sickness.actions.load-all.start',
    SUCCESS: 'r.reports-of-sickness.actions.load-all.success',
    FAILED: 'r.reports-of-sickness.actions.load-all.failed'
  },
  LoadForEmployee: {
    START: 'r.reports-of-sickness.actions.load-for-employee.start',
    SUCCESS: 'r.reports-of-sickness.actions.load-for-employee.success',
    FAILED: 'r.reports-of-sickness.actions.load-for-employee.failed'
  },
  Create: {
    START: 'r.reports-of-sickness.actions.create.start',
    SUCCESS: 'r.reports-of-sickness.actions.create.success',
    FAILED: 'r.reports-of-sickness.actions.create.failed'
  },
  Update: {
    START: 'r.reports-of-sickness.actions.update.start',
    SUCCESS: 'r.reports-of-sickness.actions.update.success',
    FAILED: 'r.reports-of-sickness.actions.update.failed'
  },
  Delete: {
    START: 'r.reports-of-sickness.actions.delete.start',
    SUCCESS: 'r.reports-of-sickness.actions.delete.success',
    FAILED: 'r.reports-of-sickness.actions.delete.failed'
  },

  Period: {
    Create: {
      START: 'r.reports-of-sickness.actions.period.create.start',
      SUCCESS: 'r.reports-of-sickness.actions.period.create.success',
      FAILED: 'r.reports-of-sickness.actions.period.create.failed'
    },
    Update: {
      START: 'r.reports-of-sickness.actions.periods.update.start',
      SUCCESS: 'r.reports-of-sickness.actions.period.update.success',
      FAILED: 'r.reports-of-sickness.actions.period.update.failed'
    },
    Delete: {
      START: 'r.reports-of-sickness.actions.periods.delete.start',
      SUCCESS: 'r.reports-of-sickness.actions.period.delete.success',
      FAILED: 'r.reports-of-sickness.actions.period.delete.failed'
    }
  },

  Recovery: {
    Create: {
      START: 'r.reports-of-sickness.actions.recovery.create.start',
      SUCCESS: 'r.reports-of-sickness.actions.recovery.create.success',
      FAILED: 'r.reports-of-sickness.actions.recovery.create.failed'
    },
    Update: {
      START: 'r.reports-of-sickness.actions.recovery.update.start',
      SUCCESS: 'r.reports-of-sickness.actions.recovery.update.success',
      FAILED: 'r.reports-of-sickness.actions.recovery.update.failed'
    },
    Delete: {
      START: 'r.reports-of-sickness.actions.recovery.delete.start',
      SUCCESS: 'r.reports-of-sickness.actions.recovery.delete.success',
      FAILED: 'r.reports-of-sickness.actions.recovery.delete.failed'
    }
  },

  UwvDecision: {
    Create: {
      START: 'r.reports-of-sickness.actions.uwv-decision.create.start',
      SUCCESS: 'r.reports-of-sickness.actions.uwv-decision.create.success',
      FAILED: 'r.reports-of-sickness.actions.uwv-decision.create.failed'
    }
  }
};

const Mutations = {
  SET: 'r.reports-of-sickness.mutations.set',
  ADD: 'r.reports-of-sickness.mutations.add',
  CLEAR: 'r.reports-of-sickness.mutations.clear',

  REMOVE: 'r.reports-of-sickness.mutations.remove',
  UPDATE: 'r.reports-of-sickness.mutations.update',
  REPLACE: 'r.reports-of-sickness.mutations.replace',
  UPSERT: 'r.reports-of-sickness.mutations.upsert',

  Period: {
    REMOVE: 'r.reports-of-sickness.mutations.period.remove'
  },

  Recovery: {
    REMOVE: 'r.reports-of-sickness.mutations.recovery.remove'
  },

  IsLoading: {
    SET: 'r.reports-of-sickness.mutations.is-loading.set',
    CLEAR: 'r.reports-of-sickness.mutations.is-loading.clear'
  }
};

const Endpoints = {
  LoadAll: (employerId) => `${Config.API.BASE_URL}/api/ReportsOfSickness/Employer/${employerId}`,
  LoadForEmployee: (employerId, employeeId) => `${Config.API.BASE_URL}/api/ReportsOfSickness/Employer/${employerId}/Employee/${employeeId}`,

  Load: (id) => `${Config.API.BASE_URL}/api/ReportsOfSickness/${id}`,
  Create: () => `${Config.API.BASE_URL}/api/ReportsOfSickness`,
  Update: (id) => `${Config.API.BASE_URL}/api/ReportsOfSickness/${id}`,
  Delete: (id) => `${Config.API.BASE_URL}/api/ReportsOfSickness/${id}`,

  Periods: {
    Create: (id) => `${Config.API.BASE_URL}/api/ReportsOfSickness/${id}/Periods`,
    Update: (id, periodId) => `${Config.API.BASE_URL}/api/ReportsOfSickness/${id}/Periods/${periodId}`,
    Delete: (id, periodId) => `${Config.API.BASE_URL}/api/ReportsOfSickness/${id}/Periods/${periodId}`
  },

  Recovery: {
    Create: (id) => `${Config.API.BASE_URL}/api/ReportsOfSickness/${id}/Recovery`,
    Update: (id) => `${Config.API.BASE_URL}/api/ReportsOfSickness/${id}/Recovery`,
    Delete: (id) => `${Config.API.BASE_URL}/api/ReportsOfSickness/${id}/Recovery`
  },

  UwvDecisions: {
    Create: (id) => `${Config.API.BASE_URL}/api/ReportsOfSickness/${id}/UwvDecisions`
  }
};

export default {
  Actions,
  Mutations,
  Endpoints
};
